__webpack_require__.p = "https://signup.focus.stg.teamleader.eu/";